module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "projects-page"
  }, [_c('div', {
    staticClass: "project"
  }, [_c('router-link', {
    staticClass: "project-container",
    attrs: {
      "to": '/' + _vm.lang + '/projects' + _vm.primary.url
    }
  }, [_c('div', {
    staticClass: "project-content"
  }, [_c('div', {
    staticClass: "project-content__info"
  }, [_c('div', {
    ref: "cat",
    staticClass: "project-content__category"
  }, [_vm._v(_vm._s(_vm.primary.cat))]), _c('div', {
    ref: "title",
    staticClass: "project-content__title"
  }, [_vm._v(_vm._s(_vm.primary.title || 'Project title'))])]), _c('base-button', {
    ref: "button",
    staticClass: "project-content__button",
    attrs: {
      "url": '/' + _vm.lang + '/projects' + _vm.primary.url,
      "label": _vm.$t('open-case')
    }
  })], 1), _c('div', {
    ref: "thumb",
    staticClass: "project-thumb",
    style: (_vm.getBackgroundImage(_vm.primary))
  })]), _c('transition-wrapper', {
    attrs: {
      "appear": true
    }
  }, [_c('scroll-marker', {
    staticClass: "project-scroll",
    attrs: {
      "dark-mode": true,
      "label": _vm.$t('more-cases')
    },
    on: {
      "click": _vm.scroll
    }
  })], 1)], 1), _c('transition-wrapper', {
    attrs: {
      "appear": true
    }
  }, [_c('list', {
    ref: "list",
    attrs: {
      "type": "projects",
      "items": _vm.items,
      "count": _vm.count - 1
    },
    on: {
      "load-more-items": _vm.loadMore
    }
  })], 1), _c('the-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-464149a6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/list/projects.vue
// module id = 481
// module chunks = 0